import script from "./RegistrationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationPage.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationPage.vue?vue&type=style&index=0&id=0c3b29c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c3b29c1"]])

export default __exports__